export function extractSpotId() {
  var url = window.location.href;
  var spotId;
  var index = url.indexOf('spot/sp_');
  if (index > -1) {
    url = url.substring(index + 5);
    spotId = url.substring(0, url.indexOf('/'));
  } else {
    let spotIdIndex = url.indexOf('spot_id');
    if (spotIdIndex > -1) {
      url = url.substring(spotIdIndex + 8);
      spotId = url.indexOf('&') === -1 ? url : url.substring(0, url.indexOf('&'));
    }
  }

  return spotId;
}

export function extractNetworkName() {
  var url = window.location.href;
  var networkName = 'spotim';
  var match1 = url.match(/network\/(.+)/);
  var match2 = url.match(/spot_im_network_name=(.+)&spot_reset_password/);
  if (match1) {
    networkName = match1[1];
  } else if (match2) {
    networkName = match2[1];
  }

  return networkName;
}
